// components/Diagnostico/diagnostico.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./diagnostico.css";
import { FaArrowLeft } from "react-icons/fa";

export default function Diagnostico() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nome: "",
    whatsapp: "",
    segmento: "",
    presencaDigital: "",
    desafio: "",
    trafegoPago: "",
    descobrir: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2 },
    );

    const elements = document.querySelectorAll(".animate-on-scroll");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateField = (name, value) => {
    if (!value || value.trim() === "") {
      return `${name.charAt(0).toUpperCase() + name.slice(1)} é obrigatório`;
    }
    if (name === "whatsapp") {
      const cleaned = value.replace(/\D/g, "");
      if (cleaned.length < 10) {
        return "WhatsApp inválido";
      }
    }
    return "";
  };

  const validateForm = () => {
    const newErrors = {};
    const fields = [
      "nome",
      "whatsapp",
      "segmento",
      "presencaDigital",
      "desafio",
      "trafegoPago",
      "descobrir",
    ];

    fields.forEach((field) => {
      const error = validateField(field, formData[field]);
      if (error) newErrors[field] = error;
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    const mensagem = `*📋 DIAGNÓSTICO R$ 97 - CONECTALM*

👤 Nome: ${formData.nome}
📱 WhatsApp: ${formData.whatsapp}
🏢 Segmento: ${formData.segmento}
🌐 Presença Digital: ${formData.presencaDigital}
🎯 Maior Desafio: ${formData.desafio}
💰 Tráfego Pago: ${formData.trafegoPago}
🔍 O que quer descobrir: ${formData.descobrir}

`;

    const url = `https://wa.me/5598986064394?text=${encodeURIComponent(mensagem)}`;
    window.open(url, "_blank");
    setIsSubmitting(false);
  };

  const handleVoltar = () => {
    navigate("/");
  };

  const opcoesPresenca = [
    "Sim, ambos",
    "Só site",
    "Só redes sociais",
    "Não tenho nenhum",
  ];

  const opcoesDesafio = [
    "Vendas",
    "Presença digital",
    "Organização interna",
    "Atendimento",
    "Um pouco de tudo",
  ];

  const opcoesTrafego = ["Sim", "Não", "Já investi antes"];

  const opcoesDescobrir = [
    "Por que não estou vendendo mais",
    "Se meu site/redes estão me atrapalhando",
    "Por onde começar a organizar minha presença digital",
    "Só quero uma visão geral e honesta",
  ];

  return (
    <section className="diagnostico-page">
      <div className="diagnostico-container">
        {/* Botão Voltar */}
        <button className="btn-voltar" onClick={handleVoltar}>
          <FaArrowLeft /> Voltar para o início
        </button>

        {/* HEADER */}
        <div className="diagnostico-header animate-on-scroll">
          <h1 className="diagnostico-title">
            Diagnóstico <span className="highlight-rosa">Estratégico</span>
          </h1>
          <p className="diagnostico-subtitle">
            Preencha o formulário abaixo e receba um diagnóstico completo da sua
            marca por apenas R$97
          </p>
        </div>

        {/* FORMULÁRIO */}
        <div className="diagnostico-form-wrapper animate-on-scroll">
          <form className="diagnostico-form" onSubmit={handleSubmit}>
            {/* Campo 1: Nome */}
            <div className="form-group">
              <label htmlFor="nome">
                Nome / Nome da empresa <span className="required">*</span>
              </label>
              <input
                type="text"
                id="nome"
                name="nome"
                value={formData.nome}
                onChange={handleChange}
                placeholder="Ex: João Silva ou Empresa XYZ"
                className={errors.nome ? "error" : ""}
              />
              {errors.nome && <span className="error-text">{errors.nome}</span>}
            </div>

            {/* Campo 2: WhatsApp */}
            <div className="form-group">
              <label htmlFor="whatsapp">
                WhatsApp <span className="required">*</span>
              </label>
              <input
                type="tel"
                id="whatsapp"
                name="whatsapp"
                value={formData.whatsapp}
                onChange={handleChange}
                placeholder="(98) 99999-9999"
                className={errors.whatsapp ? "error" : ""}
              />
              {errors.whatsapp && (
                <span className="error-text">{errors.whatsapp}</span>
              )}
            </div>

            {/* Campo 3: Segmento */}
            <div className="form-group">
              <label htmlFor="segmento">
                Qual o segmento do seu negócio?{" "}
                <span className="required">*</span>
              </label>
              <input
                type="text"
                id="segmento"
                name="segmento"
                value={formData.segmento}
                onChange={handleChange}
                placeholder="Ex: Moda, Alimentação, Tecnologia, etc."
                className={errors.segmento ? "error" : ""}
              />
              {errors.segmento && (
                <span className="error-text">{errors.segmento}</span>
              )}
            </div>

            {/* Campo 4: Presença Digital */}
            <div className="form-group">
              <label htmlFor="presencaDigital">
                Você já tem site e redes sociais ativas?{" "}
                <span className="required">*</span>
              </label>
              <select
                id="presencaDigital"
                name="presencaDigital"
                value={formData.presencaDigital}
                onChange={handleChange}
                className={errors.presencaDigital ? "error" : ""}
              >
                <option value="">Selecione uma opção</option>
                {opcoesPresenca.map((opcao) => (
                  <option key={opcao} value={opcao}>
                    {opcao}
                  </option>
                ))}
              </select>
              {errors.presencaDigital && (
                <span className="error-text">{errors.presencaDigital}</span>
              )}
            </div>

            {/* Campo 5: Desafio */}
            <div className="form-group">
              <label htmlFor="desafio">
                Qual seu maior desafio hoje? <span className="required">*</span>
              </label>
              <select
                id="desafio"
                name="desafio"
                value={formData.desafio}
                onChange={handleChange}
                className={errors.desafio ? "error" : ""}
              >
                <option value="">Selecione uma opção</option>
                {opcoesDesafio.map((opcao) => (
                  <option key={opcao} value={opcao}>
                    {opcao}
                  </option>
                ))}
              </select>
              {errors.desafio && (
                <span className="error-text">{errors.desafio}</span>
              )}
            </div>

            {/* Campo 6: Tráfego Pago */}
            <div className="form-group">
              <label htmlFor="trafegoPago">
                Você já investe em tráfego pago?{" "}
                <span className="required">*</span>
              </label>
              <select
                id="trafegoPago"
                name="trafegoPago"
                value={formData.trafegoPago}
                onChange={handleChange}
                className={errors.trafegoPago ? "error" : ""}
              >
                <option value="">Selecione uma opção</option>
                {opcoesTrafego.map((opcao) => (
                  <option key={opcao} value={opcao}>
                    {opcao}
                  </option>
                ))}
              </select>
              {errors.trafegoPago && (
                <span className="error-text">{errors.trafegoPago}</span>
              )}
            </div>

            {/* Campo 7: O que quer descobrir */}
            <div className="form-group">
              <label htmlFor="descobrir">
                O que você mais quer descobrir com esse diagnóstico?{" "}
                <span className="required">*</span>
              </label>
              <select
                id="descobrir"
                name="descobrir"
                value={formData.descobrir}
                onChange={handleChange}
                className={errors.descobrir ? "error" : ""}
              >
                <option value="">Selecione uma opção</option>
                {opcoesDescobrir.map((opcao) => (
                  <option key={opcao} value={opcao}>
                    {opcao}
                  </option>
                ))}
              </select>
              {errors.descobrir && (
                <span className="error-text">{errors.descobrir}</span>
              )}
            </div>

            <button
              type="submit"
              className="submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting
                ? "Enviando..."
                : "ENVIAR E COMBINAR MEU DIAGNÓSTICO"}
            </button>

            <p className="aviso-entrega">
              Você recebe retorno em até 48h a 72h pelo WhatsApp.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
}
